module.exports = __webpack_public_path__ + "img/2254491-91-1.bf6b5027.png";